import React from 'react'

function WhoAmI() {
  return (
    <div>
      whoami
    </div>
  )
}

export default WhoAmI
